<h2 mat-dialog-title>
  Leave page
</h2>
<mat-dialog-content>
  Are you sure you want to leave this page? All changes will be lost.
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-raised-button [mat-dialog-close]="false">No - Stay</button>
  <button mat-flat-button color="primary" [mat-dialog-close]="true">Yes - Leave</button>
</mat-dialog-actions>
